// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ysUY","newExpiryDate":"styles_newExpiryDate__3qhg9","footer":"styles_footer__1mooY"};